import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import dayjs from "dayjs";

interface UseContdownProps {
    targetDate: dayjs.Dayjs | null,
    onExpired?: () => void
}

const useCountdown = (props: UseContdownProps) => {
    const intervalIdRef = useRef<NodeJS.Timer | undefined>(undefined);

    const initialValue = useMemo<number>(() => {
        const currentTime = dayjs();
        if (currentTime.isAfter(props.targetDate) || !props.targetDate) {
            return 0;
        }
        return props.targetDate.diff(currentTime, 'seconds');
    }, [props.targetDate]);

    const [remaingSeconds, setRemaingSeconds] = useState(() => initialValue);

    const stop = useCallback(() => {
        clearInterval(intervalIdRef.current);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaingSeconds(v => v - 1);
        }, 1000);
        intervalIdRef.current = interval;
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (remaingSeconds === 0 && initialValue > 0) {
            clearInterval(intervalIdRef.current);
            props.onExpired?.();
        }
    }, [remaingSeconds])

    return {
        hours: Math.floor(remaingSeconds / (60 * 60)),
        minutes: Math.floor(remaingSeconds / 60),
        seconds: remaingSeconds % 60,
        percentage: remaingSeconds * 100 / initialValue,
        stop
    };
};

export default useCountdown;
